/* src/app/shared/components/modals/estimated-delivery-weeks/estimated-delivery-weeks.component.scss */
.delivery-avatar-reseller {
  background-color: color-mix(in srgb, var(--brand-primary) 20%, transparent);
  color: var(--brand-primary);
}
.delivery-avatar-object {
  background-color: color-mix(in srgb, var(--brand-warning) 20%, transparent);
  color: var(--brand-warning);
}
.delivery-avatar-update {
  background-color: color-mix(in srgb, var(--brand-text-subtle) 20%, transparent);
  color: var(--brand-primary);
}
.delivery-group {
  align-items: center;
  display: flex;
  flex: 1 1 0;
  gap: 0.75rem;
  min-width: 0;
}
.delivery-week-info {
  flex: 1 1 0;
}
.delivery-group-details {
  min-width: 0;
}
.delivery-group-details h4 {
  margin: 0;
}
@media (max-width: 767.98px) {
  .delivery-week-info {
    display: none !important;
  }
}
:host ::ng-deep tbody.p-datatable-tbody > tr:last-child > td {
  border-bottom: none;
}
/*# sourceMappingURL=estimated-delivery-weeks.component.css.map */
